export interface DespachoDetalle {
  id_producto: number;
  nom_producto: string;
  kilos?: number;
  unidades?: number;
  unidades_kilo_producto?: number;
  precio_kilo_producto?: number;
  subtotal: number;
}

export interface Despacho {
  id_despacho: number;
  codigo_barra: string;
  estado_pago: number; // 0 pendiente, 1 pagado
  estado_desp: number;
  cliente: string;
  repartidor: string;
  detalle: DespachoDetalle[];
  total: number;
}

//const BASE_URL = (process.env as any)?.API_PANA || (typeof window !== 'undefined' ? (window as any).__APP_CONFIG__?.API_PANA : undefined) || 'http://pana2_sistema.test/api';
const BASE_URL = 'https://poschile.net/pana/api';

export const panaApi = {
  async getDespachoByBarra(codigo_barra: string): Promise<{ ok: boolean; despacho?: Despacho; message?: string }>{
    const res = await fetch(`${BASE_URL}/despachos/by-barra`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ codigo_barra })
    });
    if (res.status === 404) return { ok: false, message: 'Despacho no encontrado' };
    if (!res.ok) return { ok: false, message: `HTTP ${res.status}` };
    
    // Solución a pérdida de precisión en JS para números > MAX_SAFE_INTEGER
    const text = await res.text();
    const safeText = text.replace(/"codigo_barra"\s*:\s*(\d+)/g, '"codigo_barra":"$1"');
    const data = JSON.parse(safeText);
    
    return data;
  },

  async setEstadoPago(codigo_barra: string, estado_pago: 0 | 1, id_usuario_pos?: number): Promise<{ ok: boolean; message?: string }>{
    const res = await fetch(`${BASE_URL}/despachos/set-estado`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ codigo_barra, estado_pago, id_usuario_pos })
    });
    if (!res.ok) return { ok: false, message: `HTTP ${res.status}` };
    const data = await res.json();
    return data;
  },

  async getPagosPos(fecha: string, id_usuario_pos?: string): Promise<any> {
    const res = await fetch(`${BASE_URL}/saldos/pagos-pos`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fecha, id_usuario_pos })
    });
    if (!res.ok) return { ok: false, message: `HTTP ${res.status}` };
    const data = await res.json();
    return data;
  }
};

export default panaApi;
